<script>
  import {
    generalPlanData,
    currentScenario,
    currentAge,
    currentYearsOfService,
    ageAtRetirement,
    currentFinalAverageSalaryFormatted,
    maxSalaryFlag,
    reportCopy,
    getCopyId,
    currentFinalAverageSalary,
  } from "../../stores/currentSelections.js";
  import Tooltip from "./Tooltip.svelte";

  export let input;
  export let type;
  let order = type === "years" ? "order-last" : "";

  $: copyKey = getCopyKey($currentScenario);
  $: title = getCopyId($reportCopy, `calculator-inputs-${copyKey}`);
  $: tooltip = getCopyId($reportCopy, `calculator-inputs-${copyKey}-tooltip`);
  $: addYearFlagCopy = getCopyId($reportCopy, `flag-add-year`);
  $: retirementFlagCopy = getCopyId($reportCopy, `flag-retirement`);
  $: maxSalaryFlagCopy = getCopyId($reportCopy, `flag-max-salary`);

  $: hasBottomMargin =
    input === "currentFinalAverageSalary" && $currentScenario === 5;
  $: hasAddYearFlag =
    input === "currentYearsOfService" && $currentScenario === 3;
  $: hasRetirementFlag = input === "ageAtRetirement";
  $: hasMaxSalaryFlag = input === "currentFinalAverageSalary" && $maxSalaryFlag;

  function getCopyKey(scenario) {
    if (input === "currentAge") return "current-age";
    if (input === "currentYearsOfService") return "current-years";
    if (input === "ageAtRetirement") return "retirement";
    if (input === "currentFinalAverageSalary") {
      if (scenario === 1 || scenario === 5) {
        return "final-salary";
      }
      return "current-salary";
    }
  }

  let htmlInput;

  function checkInput(min, max, input) {
    if (htmlInput) {
      let currentValue = +htmlInput.value;
      let calculatedValue;

      if (min && min > currentValue) {
        calculatedValue = min;
      } else if (max && max < currentValue) {
        calculatedValue = max;
      } else {
        calculatedValue = currentValue;
      }

      htmlInput.value = calculatedValue;

      if (input == "currentAge") $currentAge = calculatedValue;
      if (input === "currentYearsOfService")
        $currentYearsOfService = calculatedValue;
      if (input === "ageAtRetirement") $ageAtRetirement = calculatedValue;
    }
  }

  function checkSalaryInput(min, max) {
    if (htmlInput) {
      let currentValue = +htmlInput.value.replace(/[\D\s\._\-]+/g, "");
      let calculatedValue;

      if (min && min > currentValue) {
        calculatedValue = min;
      } else if (max && max < currentValue) {
        calculatedValue = max;
      } else {
        calculatedValue = currentValue;
      }

      htmlInput.value = calculatedValue.toLocaleString("en-US");
      $currentFinalAverageSalaryFormatted = formatLocale(calculatedValue);
    }
  }

  function formatLocale(value) {
    return value.toLocaleString("en-US");
  }
</script>

<div>
  <div
    class="flex flex-row items-center {hasBottomMargin ? 'margin-nudge' : ''}"
  >
    <p class="mb-2 text-lg text-black md:text-xl lg:text-2xl tight">{title}</p>
    <div class="ml-1">
      <Tooltip
        content={tooltip}
        yTranslate="0.25"
        yTranslateDir=""
        hidden={input === "currentAge"}
      />
    </div>
  </div>
  <div class="flex w-auto h-12 border rounded-sm flex-nowrap border-neutral-5">
    <div class="bg-neutral-5 {order} h-12 flex content-center items-center">
      <p class="px-2 font-medium text-neutral">{type}</p>
    </div>
    {#if input === "currentAge"}
      <input
        type="number"
        bind:this={htmlInput}
        on:keyup={() => checkInput(0, 150, "currentAge")}
      />
    {:else if input === "currentYearsOfService"}
      <input
        type="number"
        bind:this={htmlInput}
        on:keyup={() => checkInput(0, 65, "currentYearsOfService")}
      />
    {:else if input === "ageAtRetirement"}
      <input
        type="number"
        bind:this={htmlInput}
        on:keyup={() => checkInput(0, 65, "ageAtRetirement")}
      />
    {:else if input === "currentFinalAverageSalary"}
      <input
        type="text"
        bind:this={htmlInput}
        on:keyup={() =>
          checkSalaryInput(0, $generalPlanData["max_pensionable_salary"])}
      />
    {/if}
  </div>
  {#if hasAddYearFlag}
    <div class="mt-2">
      <p class="font-medium tight text-neutral-2">
        {@html addYearFlagCopy}
      </p>
    </div>
  {/if}
  {#if hasRetirementFlag}
    <div class="mt-2">
      <p class="font-medium tight text-neutral-2">
        {@html retirementFlagCopy}
      </p>
    </div>
  {/if}
  {#if hasMaxSalaryFlag}
    <div class="mt-2">
      <p class="mt-2 font-medium tight text-bright-2">
        {maxSalaryFlagCopy}
      </p>
    </div>
  {/if}
</div>

<style>
  input {
    @apply h-12 w-full bg-none bg-opacity-0 px-2 text-base md:text-lg lg:text-xl border-neutral-5 border;
  }

  .margin-nudge {
    margin-bottom: 8px;
  }

  @media only screen and (max-width: 767px) {
    .margin-nudge {
      margin-bottom: 0px;
    }
  }
</style>
